import {
    Events,
    Feuds,
    FeudSegmentsHash,
    SegmentItems,
    SegmentParticipantsHash,
    Superstars,
    TagTeams
} from "./models.js";

function Segment() {

    // String
    const consequenceAppliedTo = null;
    const objectName = 'segment';

    // Integer
    const order = null;
    const hype = null;

    // Float
    const rating = null;

    // Boolean
    const hot = false;
    const hidden = false;

    // Arrays
    const participants = [];

    // Objects
    const consequenceData = {};
    const managersUsed = {};

    // Foreign keys
    const feudId = null;
    const segmentItemId = null;
    const eventId = null;

    return {
        consequenceAppliedTo,
        order,
        hype,
        rating,
        hot,
        hidden,
        participants,
        consequenceData,
        managersUsed,
        feudId,
        segmentItemId,
        eventId,
        objectName,
    };
}

function getSegmentEvent(segment) {
    return Events.find({'$loki': segment.eventId})[0];
}

function getSegmentSegmentItem(segment) {
    return SegmentItems.find({'$loki': segment.segmentItemId})[0];
}

function getSegmentFeud(segment) {
    return Feuds.find({'$loki': segment.feudId})[0];
}

function addSegmentSuperstars(segment, superstars) {
    let segmentHashes = superstars.map(s => {
        return {segmentId: segment.$loki, superstarId: s.$loki}
    });
    return SegmentParticipantsHash.insert(segmentHashes);
}

async function getSegmentSuperstars(segment) {
    const segmentHashes = await SegmentParticipantsHash.find({'segmentId': segment.$loki});
    const segmentSuperstarIds = segmentHashes.map(x => x.superstarId);
    const superstarIds = segmentHashes.map(x => {
        return x.superstarId
    }).filter(y => y);
    const result = Superstars.find({'$loki': {'$in': superstarIds}});
    result.sort((a, b) => segmentSuperstarIds.indexOf(a.$loki) - segmentSuperstarIds.indexOf(b.$loki));
    return result;
}

function addSegmentTagTeams(segment, tagTeams) {
    let segmentHashes = tagTeams.map(s => {
        return {segmentId: segment.$loki, tagTeamId: s.$loki}
    });
    return SegmentParticipantsHash.insert(segmentHashes);
}

async function getSegmentTagTeams(segment) {
    const segmentHashes = await SegmentParticipantsHash.find({'segmentId': segment.$loki});
    const segmentTagTeamIds = segmentHashes.map(x => x.tagTeamId);
    const tagTeamIds = segmentHashes.map(x => {
        return x.tagTeamId
    }).filter(y => y);
    const result = TagTeams.find({'$loki': {'$in': tagTeamIds}});
    result.sort((a, b) => segmentTagTeamIds.indexOf(a.$loki) - segmentTagTeamIds.indexOf(b.$loki));
    return result;
}

async function getSegmentParticipants(segment) {
    let participants = [];
    const segmentSuperstars = await getSegmentSuperstars(segment);
    if (segmentSuperstars) {
        participants.push(...segmentSuperstars)
    }
    const segmentTagTeams = await getSegmentTagTeams(segment);
    if (segmentTagTeams) {
        participants.push(...segmentTagTeams)
    }
    return participants;
}

async function removeSegmentParticipants(segment) {
    return SegmentParticipantsHash.findAndRemove({'segmentId': segment.$loki});
}

async function addSegmentParticipants(segment, participants) {
    for (const p of participants) {
        if (p.objectName === 'superstar') {
            await addSegmentSuperstars(segment, [p])
        }
        else if (p.objectName === 'tagTeam') {
            await addSegmentTagTeams(segment, [p])
        }
    }
}

function addSegmentFeuds(segment, feuds) {
    let segmentHashes = feuds.map(x => {
        return {segmentId: segment.$loki, feudId: x.$loki}
    });
    return FeudSegmentsHash.insert(segmentHashes);
}

async function removeSegmentFeud(segment, feud) {
    return FeudSegmentsHash.findAndRemove({'segmentId': segment.$loki, 'feudId': feud.$loki});
}

async function getSegmentFeuds(segment) {
    const segmentHashes = await FeudSegmentsHash.find({'segmentId': segment.$loki});
    const feudIds = segmentHashes.map(x => {
        return x.feudId
    });
    return Feuds.find({'$loki': {'$in': feudIds}});
}


export { Segment, getSegmentEvent, getSegmentFeud, getSegmentSegmentItem, addSegmentSuperstars,
    getSegmentSuperstars, addSegmentTagTeams, getSegmentTagTeams, getSegmentParticipants, addSegmentFeuds,
    getSegmentFeuds, removeSegmentParticipants, addSegmentParticipants, removeSegmentFeud}
